import { configureStore } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import { SideMenuProps } from './modules/sideMenu/reducer'
import { TrackListRemoteProps } from './modules/trackListRemote/reducer'
import { ArtistsProps } from './modules/artists/reducer'
import { MusicalGenresProps } from './modules/musicalGenres/reducer'
import { LicensesProps } from './modules/licenses/reducer'
import { MoodsProps } from './modules/moods/reducer'
import { AlbumsProps } from '@/types/albumsProps'
import { SocialMediaProps } from './modules/socialMedia/reducer'
import { UsersProps } from './modules/users/reducer'
import { AdminDataProps } from './modules/admin/reducer'
import { CampaignsStateProps } from './modules/campaigns/reducer'
import { ScenesProps } from './modules/scenes/reducer'
import rootReducer from './modules/rootReducer'

export interface ReduxProps {
  sideMenu: SideMenuProps
  trackListRemote: TrackListRemoteProps
  musicalGenres: MusicalGenresProps
  licenses: LicensesProps
  moods: MoodsProps
  albums: AlbumsProps
  socialMedia: SocialMediaProps
  artists: ArtistsProps
  users: UsersProps
  admin: AdminDataProps
  campaigns: CampaignsStateProps
  scenes: ScenesProps
}

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['sideMenu'],
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
})

const persistor = persistStore(store)

export { store, persistor }
